export default __webpack_public_path__ + "static/media/Stamp9.f69c7f42.svg";